/**
 * Where focus goes after a navigation link in the shell is followed.
 *
 * Every page renders its own <Layout>, so following a link from the rail (or
 * the drawer) destroys the link that had focus, and focus falls back to
 * <body>: a keyboard or screen-reader user has to start again from the top.
 * The link asks for the new page's main content instead; the next <Layout>
 * to mount takes the request. A link to the page already shown focuses the
 * current main content straight away.
 */
let pending = false;

/** Ask the next page to focus its main content. */
export function focusMainOnNextPage() {
  pending = true;
}

/** Called by a freshly mounted <Layout>: honour a pending request, if any. */
export function takePendingMainFocus(main) {
  if (!pending) return false;
  pending = false;
  main?.focus({ preventScroll: true });
  return true;
}

/** Focus the main content of the page already shown. */
export function focusMainNow(main) {
  pending = false;
  main?.focus({ preventScroll: true });
}
